import { render, staticRenderFns } from "./ResourceSyncingUiAlert.vue?vue&type=template&id=dc779460"
import script from "./ResourceSyncingUiAlert.vue?vue&type=script&lang=js"
export * from "./ResourceSyncingUiAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports